import { ApolloError } from '@apollo/client'

export const ApolloErrorMessage = ({ error }: { error: ApolloError }) => {
  return (
    <div>
      <h1>Error</h1>
      <p>{error.message}</p>
    </div>
  )
}
